import { NEW_WHEEL_NAME } from '../../features/wheel/features/wheel-name-form/wheel-name-form.component';
import { SingleWheelState } from '../../state/typings';

export function mapPendingFreePlanWheel(activeWheel: SingleWheelState): PendingFreePlanWheelPayload {
  return {
    wheel: {
      name: activeWheel.name ?? NEW_WHEEL_NAME,
      categoryIds: [],
      isDefault: true,
    },
    categories: activeWheel.categories.map(({ name, description, color, score }) => ({
      label: name,
      description,
      color,
      score,
    })),
  };
}
